import { render, staticRenderFns } from "./SelectTag.vue?vue&type=template&id=9533e942&"
import script from "./SelectTag.vue?vue&type=script&lang=ts&"
export * from "./SelectTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports